import { Mic } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/shared/components/shadcn/Button";
import { TextArea } from "@/shared/components/shadcn/TextArea";
import { Card } from "@/shared/components/ui/Card";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { DashboardHeader } from "../components/DashboardHeader";
import wizard from "../assets/froppio-wizard.svg";

export function AssistantPage() {
  const { businessId, locationId } = useParams();
  const navigate = useNavigate();
  const { goToAppointmentAdd, goToAppointments } = useAppNavigation();

  return (
    <Page>
      <DashboardHeader view="assistant" />
      <PageContent className="max-w-[680px] pt-3">
        <div className="mb-5 flex items-center justify-between gap-4">
          <h1 className="min-w-0 text-xl font-extrabold leading-[1.3]">A pinch of magic for your business.</h1>
          <img src={wizard} width={280} height={240} alt="Froppio in a magic hat, holding a wizard wand" className="h-auto w-[clamp(100px,28vw,132px)] shrink-0" />
        </div>
        <Card role="region" aria-label="Ask Froppio">
          <label htmlFor="assistant-prompt" className="mb-2.5 block text-sm font-semibold">Your request</label>
          <TextArea id="assistant-prompt" rows={3} placeholder="Describe what you need…" disabled aria-describedby="assistant-unavailable" className="min-h-[115px]" />
          <div className="mt-3 flex items-center justify-between gap-3">
            <Button variant="ai" size="icon" disabled aria-label="Voice input unavailable" aria-describedby="assistant-unavailable"><Mic aria-hidden="true" /></Button>
            <Button variant="ai" disabled aria-describedby="assistant-unavailable">Ask Froppio <span aria-hidden="true">→</span></Button>
          </div>
          <div className="mt-4 flex flex-wrap gap-1.5" role="group" aria-label="Continue with a manual workflow">
            <Button variant="outline" className="min-h-11 rounded-full px-2.5 text-xs" onClick={() => goToAppointmentAdd()}>Book a client</Button>
            <Button variant="outline" className="min-h-11 rounded-full px-2.5 text-xs" onClick={() => navigate(`/b/${businessId}/l/${locationId}/appointments?status=pending`)}>Review pending</Button>
            <Button variant="outline" className="min-h-11 rounded-full px-2.5 text-xs" onClick={goToAppointments}>Find an opening</Button>
          </div>
          <p id="assistant-unavailable" className="mt-4 text-sm leading-relaxed text-muted-foreground">
            AI assistance and voice input are not available yet. No requests are sent and no audio is recorded. These shortcuts open the real booking and calendar pages so you can continue manually.
          </p>
        </Card>
        <p className="mt-6 text-center text-sm leading-relaxed text-muted-foreground">You're in control. Review and confirm before Froppio makes any changes.</p>
      </PageContent>
    </Page>
  );
}
